import BaseComponent from "../components/BaseComponent";
import {AdaptivityContext, getGUID, inducement} from "./constants";
import React from "react";
import BaseApi from "../api/BaseApi";
import {Button, Cell, FormItem, Input, List, RichCell, Spinner, SplitCol, SplitLayout} from "@vkontakte/vkui";

import {Icon20AddCircleFillGreen, Icon28HelpCircleOutline} from "@vkontakte/icons";


class SmartAutocompleteBase extends BaseComponent {
    constructor(props) {
        super(props);
        const el = props.default ?? {}
        if (el.full_address) {
            el.descr = el.full_address
        }

        const search = (el.id != undefined && el.id != -1 || el.uid != undefined && el.uid != -1) ? ((el.title ?? (el.name ?? '')) + ' ' + (el.descr ? (el.descr ?? '') : '')) : ''

        const state = {
            loading: false,
            items: [],
            current_object: {},
            search,
            page: 1,
            cnt_items: 0,
            append: false,
            totalPages: 1,
            showSearch: false,
            default_selected: false,
            default_opened: false, ...this.state,

            numItems: 7,
            showList: false,
            showCreateForm: false,
            onBottom: false,
            onRight: false
        }


        if (this.props.value) {
            state.search = this.props.value
        }
        if (this.props.numItems) {
            state.numItems = this.props.numItems
        }
        this.state = {
            ...this.state,
            ...state
        }
        this.guid = getGUID()
        this.ref = React.createRef()
    }

    checkScroll() {

        if (!this.ref.current) return
        this.currentTop = this.ref.current.getBoundingClientRect().bottom
        this.currentLeft = this.ref.current.getBoundingClientRect().left
    }

    receiveMessage = (event) => {
        if (event.data == "resetDefaultSelected") {
            //   this.setState({default_selected: false})
        }
        if (event.data == "closeSmartAutocomplete" + this.guid) {
            this.closeCreateForm()
        }
        if (event.data.type != undefined) {
            if (event.data.type == "openKBInput" && event.data.guid != this.guid) {
                this.setState({showList: false})
            }
        }
    }
    handleScroll = () => {
        this.checkScroll()
    }

    componentDidMount() {
        super.componentDidMount()
        if (this.props.default != undefined && !this.state.default_selected) {
            const el = this.props.default;

            if (el.Код != undefined) {
                this.setState({current_object: {name: el.Значение, external_id: el.Код, id: el.Код, descr: el.Тип}})
            } else {
                if ((el.id && el.id != -1 || el.uid && el.uid != -1) && el.INN) {
                    el.descr = el.INN ?? el.descr ?? ''
                }
                this.setState({current_object: el})

            }

            this.setState({default_selected: true})
        }


    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {


        if (this.props.default != prevProps.default) {
            const el = this.props.default ?? {};
            //  console.log(nextProps)
            if (el.Код != undefined) {
                this.setState({current_object: {name: el.Значение, external_id: el.Код, id: el.Код, descr: el.Тип}})
                this.props.selectObject(el)
            } else {
                if ((el.id && el.id != -1 || el.uid && el.uid != -1) && el.INN) {
                    el.descr = el.INN ?? el.descr ?? ''
                }
                const search = (el.id != undefined && el.id != -1 || el.uid != undefined) && el.uid != -1 ? ((el.title ?? el.name) + ' ' + el.descr ?? '') : ''

                this.setState({current_object: el, search, items: []})

            }
            this.setState({default_selected: true})
        }
    }

    searchInterval = null

    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({search: state.target.value});
        this.searchInterval = setInterval(() => {
            clearInterval(this.searchInterval)
            this.setState({loading: true, page: 1})
            this.getItems(this.state.search, false, 1)
        }, state.target.value == '' ? 500 : 1000)

    }
    getItems = (search_ = '', append = false, page: 1) => {
        if (this.props.items != undefined) {
            let items = [];
            this.props.items.map((el, i) => {
                items.push({name: el.Значение, external_id: el.Код, id: el.Код, descr: el.Тип})
                this.setState({items: items});
            })
        } else {
            const search = search_ ? search_ : this.state.search
            append = append == undefined ? false : append
            if (page == undefined) {
                page = this.state.page;
            }
            let sAjaxSource = '/?app=' + this.props.app + '&act=' + this.props.act
            if (this.props.params) {
                sAjaxSource = sAjaxSource + '&' + this.props.params
            }
            this.setState({loading: true})
            this.checkShowList()
            BaseApi.post(sAjaxSource, {search, page, epp: this.state.numItems},).then((response) => {
                this.setState({loading: false})
                const items = append ? this.state.items : []
                const results = response.data.results

                results.map((el, i) => {
                    el.name = el.title
                    el.uid = el.id

                    el.descr = el.descr ?? el.INN
                    items.push(el)
                })

                this.setState({
                    items: items,
                    cnt_items: response.data.iTotalRecords,
                    totalPages: response.data.iTotalPages
                })

            })
        }
    }

    checkShowList = (e) => {
        if (e) {
            e.stopPropagation()
        }
        //if (this.state.label.toString().length < 2) return;
        if (this.props.readonly && this.props.readonlyError) {
            this.props.readonlyError()
        }

        if (this.props.readonly) return
        const onBottom = this.currentTop + 250 > window.innerHeight;
        const onRight = this.currentLeft + 150 > window.innerWidth;


        window.postMessage({type: 'openSmartAutocomlete', guid: this.guid})
        this.setState({showList: true, onBottom, onRight})
    }

    renderCreateForm() {

    }

    closeCreateForm() {
        this.setState({search: '', page: 1, items: [], showCreateForm: false})
    }

    createAction() {
        this.setState({showList: false, search: '', showCreateForm: true})
    }

    goSearch = () => {
        // console.log(state);
        clearInterval(this.searchInterval);
        this.setState({loading: true, page: 1, showList: false})
        this.getItems(this.state.search, false, 1)

    }
    selectObject = (index) => {

        const current_object = this.state.items[index]

        const search = current_object.id != undefined || current_object.uid != undefined ? ((current_object.title ?? current_object.name) + ' ' + current_object.descr ?? '') : ''


        this.setState({current_object, search})
        if (this.props.selectObject != undefined) {
            this.props.selectObject(current_object)
        }

        if (this.props.clear_after_select) {
            this.setState({current_object: {}})
        }

        this.setState({showList: false})
    }

    renderRow(el, index) {
        return <Cell key={'autocomplete_select_obj' + index} multiline
                     onClick={() => this.selectObject(index)}>{el.title} {el.descr ?? ''}</Cell>
    }

    render() {

        const {items} = this.state
        const empty_rows_message = this.props.empty_rows_message ?? 'Ничего не найдено'
        const create_message = this.props.create_message ?? 'Добавить новый'

        return (
            <div ref={this.ref} className="Autocomlete" style={{...this.props.style}}>
                <SplitLayout key={`autocomplete-object-${this.guid}`}
                             className={(this.state.showCreateForm ? 'disabled-area' : '')}>
                    <SplitCol width="100%">
                        <FormItem
                            top={this.props.title}
                            bottom={this.props.error}
                            status={this.props.error ? 'error' : 'valid'}>


                            <form onSubmit={(e) => {
                                e.preventDefault()
                                this.goSearch()
                            }}>

                                <Input type="text"
                                       style={{width: '100%'}}
                                       disabled={this.state.showCreateForm}
                                       name={this.props.name}
                                       placeholder={this.props.placeholder ?? ''}
                                       after={this.props.addon ?? null}
                                       value={this.state.search}
                                       type={this.props.type}
                                       autoComplete="off"
                                       onChange={this.onSearchChange}
                                       className={this.props.className}
                                       style={{...this.props.style}}
                                       onClick={this.props.noAutoOpen ? () => {
                                       } : this.checkShowList}
                                       before={this.props.icon ? this.props.icon : ''}

                                />
                            </form>

                        </FormItem>
                    </SplitCol>
                </SplitLayout>

                {this.state.showCreateForm && this.renderCreateForm()}
                {this.state.showList && this.state.search &&
                    <div
                        className={"autocomplete-wrapper smart" + (this.state.onBottom ? " on-bottom" : '') + (this.state.onRight ? " on-right" : '')}
                        style={{
                            minWidth: AdaptivityContext.isMobile ? '200px' : '400px',
                            marginTop: this.state.onBottom ? (-95 - items.length * 44) + 'px' : 'inherit'
                        }}>
                        <List>
                            {items && items.map((el, index) => this.renderRow(el, index))}
                            {this.state.loading ?
                                <div ref={this.ref} key={"loaderSmartAutoCompleteList" + getGUID()}
                                     style={{height: '44px', width: 'auto'}}>{this.state.loading ?
                                    <Cell before="Запрашиваем данные с сервера"
                                          after={<Spinner size="large"/>}></Cell> : ""}</div> : ""}
                            {items.length === 0 && !this.state.loading &&
                                <RichCell key={'sel_obj0'} style={{
                                    width: AdaptivityContext.isMobile ? (AdaptivityContext.w - 30) + 'px' : 'auto'
                                }} className="empty_rows_message">
                                    {empty_rows_message}
                                </RichCell>}
                            {this.state.items.length < 3 && !this.state.loading && this.props.create_action &&
                                <RichCell key={'sel_obj00'} className="empty_rows_message"

                                >
                                    <Button mode="outline" stretched
                                            before={<Icon20AddCircleFillGreen/>}
                                            onClick={() => {
                                                this.createAction()
                                            }}>{create_message}</Button>
                                </RichCell>}
                            {this.state.cnt_items > 5 && !this.state.loading &&
                                <RichCell key={'sel_obj000'} className="empty_rows_message help"
                                          before={<Icon28HelpCircleOutline/>}
                                >
                                    Найдено
                                    еще {this.state.cnt_items - items.length} {inducement(this.state.cnt_items - items.length, 'позиция', 'позиции', 'позиций')},
                                    если не видно нужной позиции уточните запрос.
                                    Например добавьте фамилию, отчество, населенный пункт, улицу и тд
                                </RichCell>}
                        </List>
                    </div>}
            </div>
        )
    }
}

export default SmartAutocompleteBase